// Constants
import { PAYMENT_CHANNELS } from '@/models/Payment'

// Models
import Model from './Model'

class CalendarEvent extends Model {
  get isAllDay () {
    return this.from === null && this.till === null
  }

  get color () {
    return CALENDAR_COLORS[this.calendar]
  }

  get isEditable () {
    return this.calendar !== CALENDARS.TARGET2
  }

  static get calendarOptions () {
    return [
      { name: 'Latvian WD', value: CALENDARS.LV },
      { name: 'TARGET2 WD', value: CALENDARS.TARGET2 },
      { name: 'BluOr WD', value: CALENDARS.BLUOR_BANK },
      { name: 'CZCB WD', value: CALENDARS.CZCB },
      { name: 'iFast WD', value: CALENDARS.IFAST },
      { name: 'Incore WD', value: CALENDARS.INCORE },
      { name: 'Mano WD', value: CALENDARS.MANO },
      { name: 'BluOr US WD', value: CALENDARS.BO_US },
      { name: 'FV Bank WD', value: CALENDARS.FV_BANK }
    ]
  }

  get formatters () {
    return {
      from: value => {
        const [hours, minutes] = value.split(':')
        return [hours, minutes].join(':')
      },
      till: value => {
        const [hours, minutes] = value.split(':')
        return [hours, minutes].join(':')
      }
    }
  }

  get schema () {
    return [
      'calendar',
      'date',
      'dayType',
      'from',
      'till'
    ]
  }
}

export const CALENDARS = {
  LV: 'LV',
  TARGET2: 'TARGET2',
  BLUOR_BANK: PAYMENT_CHANNELS.BLUOR_BANK,
  CZCB: PAYMENT_CHANNELS.CZCB,
  IFAST: PAYMENT_CHANNELS.IFAST,
  INCORE: PAYMENT_CHANNELS.INCORE,
  MANO: PAYMENT_CHANNELS.MANO,
  BO_US: PAYMENT_CHANNELS.BO_US,
  FV_BANK: PAYMENT_CHANNELS.FV_BANK
}

const CALENDAR_COLORS = {
  [CALENDARS.LV]: 'primary',
  [CALENDARS.TARGET2]: 'orange',
  [CALENDARS.BLUOR_BANK]: 'indigo',
  [CALENDARS.CZCB]: 'red',
  [CALENDARS.IFAST]: 'teal',
  [CALENDARS.INCORE]: 'cyan',
  [CALENDARS.MANO]: 'light-green',
  [CALENDARS.BO_US]: 'amber',
  [CALENDARS.FV_BANK]: 'blue-grey'
}

export default CalendarEvent
